<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import FileBox from '../common/FileBox.vue'
import FilePreview from 'comp/content/FilePreview.vue'

import { getSubPageId12 } from '@/api/pageData'

export default {
  name: 'DialogId12',
  components: { ModuleTitle, FileBox, FilePreview },
  props: {
    currentModule: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      pageData: [],
      currentPageData: {},
      previewShow: false
    }
  },
  created() {
    this.initPageData()
  },
  methods: {
    onFileClick(v) {
      this.currentPageData = v
      this.previewShow = true
    },

    initPageData() {
      const params = {
        titleid: Number(this.currentModule.titleid),
        userid: localStorage.getItem('screenUserid') || 0
      }
      getSubPageId12(params).then(res => {
        if (res.code === 0) this.pageData = res.msg[0].list
      })
    }
  }
}
</script>

<template>
  <div class="dialog-id-12">
    <div class="title-container">
      <module-title :title="currentModule.title" margin-bottom="40" />
    </div>
    <div class="group-container">
      <file-box
        v-for="(v, i) in pageData"
        :key="`dialog12-file-${i}`"
        :type="v.typeid"
        :headline="v.headline"
        :cover="v.photo"
        :createtime="v.createtime"
        :filename="v.typename"
        @click.native="onFileClick(v)"
      />
    </div>

    <file-preview
      :preview-show="previewShow"
      :type="currentPageData.typeid"
      :info-id="currentPageData.id"
      :headline="currentPageData.headline"
      :filename="currentPageData.typename"
      :content="currentPageData.memo"
      :createtime="currentPageData.createtime"
      @onModalClick="previewShow = false"
    />
  </div>
</template>

<style lang="scss" scoped>
// 1330
.dialog-id-12 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title-container {
  width: 100%;
}
.group-container {
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
  width: 1150px;
  padding: 10px;
  box-sizing: border-box;
  gap: 20px;
  height: 610px;
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
}
</style>
